var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewContainer',[_c('v-card',[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.$t('page.404.notFoundTitle'))}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }